export default __webpack_public_path__ + "static/media/video2.a64205fd.mp4";